export enum RoutePath {
  Dashboard = "/",
  Login = "/",
  VerifyEmail = "/verify-email",
  Booking = "/booking",
  BookingPayment = "/booking/payment",
  ManageBookings = "/bookings",
  BookingDetail = "/bookings/:orderId",
}

export const urls = {
  privacy: "https://health4travel.com/privacy-policy/",
  termsOfUse: "https://health4travel.com/terms-and-condition/",
  returnsAndExchanges: "https://health4travel.com/privacy-policy/",
  contactUs: "https://health4travel.com/contact-us/",
  sendFeedback: "https://health4travel.com/contact-us/",
  facebook: "https://www.facebook.com/health4travel",
  twitter: "https://x.com/AirportVax",
  instagram: "https://www.instagram.com/health4travel",
  linkedin: "https://www.linkedin.com/company/health4travel/",
  bookingSuccess: ({
    order_id,
    code,
    telehealth_order = false,
    free = false,
  }: {
    order_id: string | number;
    code: string;
    telehealth_order?: boolean;
    free?: boolean;
  }) =>
    `/?paymentSuccess=true&order_id=${order_id}&code=${code}&telehealth_order=${telehealth_order}&free=${free}`,
} as const;

export type PhoneMeta = {
  dial: `+${string}`;
  flag: string;
  nationalMaxDigits: number;
  nationalFormat?: { re: RegExp; fmt: string };
};

export const phoneMeta: ReadonlyArray<PhoneMeta> = [
  { dial: "+852", flag: "🇭🇰", nationalMaxDigits: 8 },
  { dial: "+880", flag: "🇧🇩", nationalMaxDigits: 10 },
  { dial: "+886", flag: "🇹🇼", nationalMaxDigits: 9 },
  { dial: "+966", flag: "🇸🇦", nationalMaxDigits: 9 },
  { dial: "+968", flag: "🇴🇲", nationalMaxDigits: 8 },
  { dial: "+971", flag: "🇦🇪", nationalMaxDigits: 9 },
  { dial: "+972", flag: "🇮🇱", nationalMaxDigits: 9 },
  { dial: "+973", flag: "🇧🇭", nationalMaxDigits: 8 },
  { dial: "+974", flag: "🇶🇦", nationalMaxDigits: 8 },
  { dial: "+965", flag: "🇰🇼", nationalMaxDigits: 8 },
  { dial: "+233", flag: "🇬🇭", nationalMaxDigits: 9 },
  { dial: "+234", flag: "🇳🇬", nationalMaxDigits: 10 },
  { dial: "+254", flag: "🇰🇪", nationalMaxDigits: 9 },
  { dial: "+255", flag: "🇹🇿", nationalMaxDigits: 9 },
  { dial: "+256", flag: "🇺🇬", nationalMaxDigits: 9 },
  { dial: "+351", flag: "🇵🇹", nationalMaxDigits: 9 },
  { dial: "+352", flag: "🇱🇺", nationalMaxDigits: 9 },
  { dial: "+353", flag: "🇮🇪", nationalMaxDigits: 9 },
  { dial: "+354", flag: "🇮🇸", nationalMaxDigits: 7 },
  { dial: "+356", flag: "🇲🇹", nationalMaxDigits: 8 },
  { dial: "+357", flag: "🇨🇾", nationalMaxDigits: 8 },
  {
    dial: "+358",
    flag: "🇫🇮",
    nationalMaxDigits: 9,
    nationalFormat: { re: /^(\d{2})(\d{3})(\d{4})$/, fmt: "$1$2$3" },
  },
  { dial: "+359", flag: "🇧🇬", nationalMaxDigits: 9 },
  { dial: "+370", flag: "🇱🇹", nationalMaxDigits: 8 },
  { dial: "+371", flag: "🇱🇻", nationalMaxDigits: 8 },
  { dial: "+372", flag: "🇪🇪", nationalMaxDigits: 8 },
  { dial: "+380", flag: "🇺🇦", nationalMaxDigits: 9 },
  { dial: "+381", flag: "🇷🇸", nationalMaxDigits: 9 },
  { dial: "+382", flag: "🇲🇪", nationalMaxDigits: 8 },
  { dial: "+385", flag: "🇭🇷", nationalMaxDigits: 9 },
  { dial: "+386", flag: "🇸🇮", nationalMaxDigits: 8 },
  { dial: "+387", flag: "🇧🇦", nationalMaxDigits: 8 },
  { dial: "+389", flag: "🇲🇰", nationalMaxDigits: 8 },
  {
    dial: "+420",
    flag: "🇨🇿",
    nationalMaxDigits: 9,
    nationalFormat: { re: /^(\d{3})(\d{3})(\d{3})$/, fmt: "$1$2$3" },
  },
  {
    dial: "+421",
    flag: "🇸🇰",
    nationalMaxDigits: 9,
    nationalFormat: { re: /^(\d{3})(\d{3})(\d{3})$/, fmt: "$1$2$3" },
  },
  { dial: "+20", flag: "🇪🇬", nationalMaxDigits: 9 },
  { dial: "+27", flag: "🇿🇦", nationalMaxDigits: 9 },
  { dial: "+30", flag: "🇬🇷", nationalMaxDigits: 10 },
  {
    dial: "+31",
    flag: "🇳🇱",
    nationalMaxDigits: 9,
    nationalFormat: { re: /^(\d{3})(\d{3})(\d{3})$/, fmt: "$1$2$3" },
  },
  { dial: "+32", flag: "🇧🇪", nationalMaxDigits: 9 },
  {
    dial: "+33",
    flag: "🇫🇷",
    nationalMaxDigits: 9,
    nationalFormat: { re: /^(\d{3})(\d{3})(\d{3})$/, fmt: "$1$2$3" },
  },
  {
    dial: "+34",
    flag: "🇪🇸",
    nationalMaxDigits: 9,
    nationalFormat: { re: /^(\d{3})(\d{3})(\d{3})$/, fmt: "$1$2$3" },
  },
  { dial: "+36", flag: "🇭🇺", nationalMaxDigits: 9 },
  { dial: "+39", flag: "🇮🇹", nationalMaxDigits: 10 },
  { dial: "+40", flag: "🇷🇴", nationalMaxDigits: 9 },
  { dial: "+41", flag: "🇨🇭", nationalMaxDigits: 9 },
  { dial: "+43", flag: "🇦🇹", nationalMaxDigits: 12 },
  { dial: "+44", flag: "🇬🇧", nationalMaxDigits: 10 },
  { dial: "+45", flag: "🇩🇰", nationalMaxDigits: 8 },
  { dial: "+46", flag: "🇸🇪", nationalMaxDigits: 9 },
  { dial: "+47", flag: "🇳🇴", nationalMaxDigits: 8 },
  { dial: "+48", flag: "🇵🇱", nationalMaxDigits: 9 },
  { dial: "+49", flag: "🇩🇪", nationalMaxDigits: 12 },
  { dial: "+51", flag: "🇵🇪", nationalMaxDigits: 9 },
  { dial: "+52", flag: "🇲🇽", nationalMaxDigits: 10 },
  { dial: "+54", flag: "🇦🇷", nationalMaxDigits: 10 },
  { dial: "+55", flag: "🇧🇷", nationalMaxDigits: 11 },
  { dial: "+56", flag: "🇨🇱", nationalMaxDigits: 9 },
  { dial: "+57", flag: "🇨🇴", nationalMaxDigits: 10 },
  { dial: "+60", flag: "🇲🇾", nationalMaxDigits: 10 },
  { dial: "+61", flag: "🇦🇺", nationalMaxDigits: 9 },
  { dial: "+62", flag: "🇮🇩", nationalMaxDigits: 11 },
  { dial: "+63", flag: "🇵🇭", nationalMaxDigits: 10 },
  { dial: "+64", flag: "🇳🇿", nationalMaxDigits: 9 },
  { dial: "+65", flag: "🇸🇬", nationalMaxDigits: 8 },
  { dial: "+66", flag: "🇹🇭", nationalMaxDigits: 9 },
  { dial: "+81", flag: "🇯🇵", nationalMaxDigits: 10 },
  { dial: "+82", flag: "🇰🇷", nationalMaxDigits: 10 },
  { dial: "+84", flag: "🇻🇳", nationalMaxDigits: 9 },
  { dial: "+86", flag: "🇨🇳", nationalMaxDigits: 11 },
  { dial: "+90", flag: "🇹🇷", nationalMaxDigits: 10 },
  { dial: "+91", flag: "🇮🇳", nationalMaxDigits: 10 },
  { dial: "+92", flag: "🇵🇰", nationalMaxDigits: 10 },
  { dial: "+93", flag: "🇦🇫", nationalMaxDigits: 9 },
  { dial: "+94", flag: "🇱🇰", nationalMaxDigits: 9 },
  { dial: "+7", flag: "🇷🇺", nationalMaxDigits: 10 },
  {
    dial: "+1",
    flag: "🇺🇸",
    nationalMaxDigits: 10,
    nationalFormat: { re: /^(\d{3})(\d{3})(\d{4})$/, fmt: "$1$2$3" },
  },
] as const;
